import { MprcMessageBox } from "components";
import { ButtonClose } from "components/buttons";
import React from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////////

export const AccountExpired: React.FC<{ onClose: () => void; }> = ({ onClose }) => {
    const { t } = useTranslation();

    return (
        <MprcMessageBox
            variant="error"
            message={
                <>
                    <b>{t("Auth.AccountExpired.MessageL1")}</b>
                    <p>{t("Auth.AccountExpired.MessageL2")}</p>
                </>
            }
            action={<ButtonClose variant="contained" color="error" onClick={onClose} />}
        />
    );
};
